export function geolocate(timeout = 8000) {
    return new Promise((resolve, reject) => {
        if (!navigator.geolocation) { reject(new Error('Geolocation not supported')); return }
        navigator.geolocation.getCurrentPosition(
            pos => resolve(pos.coords),
            reject,
            { timeout }
        )
    })
}
